export default "__VITE_ASSET__C5K5Dis0__"